export default [
    {
        path: "products-tab",
        name: "ProductsTab",
        meta:{
            permissionPath: 'products.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "productsTab" */ "@/views/storePanel/products/tabs/ProductsTab.vue"
            )
    },

    {
        path: "product-groups",
        name: "ProductGroups",
        meta:{
            permissionPath: 'products.group.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "productGroups" */ "@/views/storePanel/products/tabs/ProductGroups.vue"
            )
    },

    {
        path: "product-categories",
        name: "ProductCategories",
        meta:{
            permissionPath: 'products.categories.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "productCategories" */ "@/views/storePanel/products/tabs/ProductCategories.vue"
            )
    },

    {
        path: "external-links",
        name: "ExternalLinks",
        meta:{
            permissionPath: 'products.external_links.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "externalLinks" */ "@/views/storePanel/products/tabs/ExternalLinks.vue"
            )
    }
];
